import { Base, Component, Inject } from '@/vue-property-decorator'
import { CardDefaultBgImg } from '../class/cardDefaultBgImg'
import { GameCategoryIds } from '@/views/game/consts/categorys'
import { LandscapeProps } from '../../components/basePropsConfig'
import style from './style.module.scss'

/** 完整独立的一张广告图片 */
@Component<AdvertiseImgIndividual>({
  name: 'AdvertiseImgIndividual'
})
export default class AdvertiseImgIndividual extends Base<
  unknown,
  unknown,
  unknown
> {
  @Inject('cardProps') cardProps!: Required<LandscapeProps>

  render() {
    const { imgUrl, bgImg, categoryId, gameName, isCustomIcon } = this.cardProps
    return (
      <my-img
        class={{
          ['advertse-img-individual']: true,
          [style['advertse-img-individual']]: true,
          [style[`type-default`]]: true
        }}
        options={{ type: 'div' }}
        src={bgImg || CardDefaultBgImg.getBgImg(categoryId as GameCategoryIds)}
      >
        {/* 完整的广告图 */}
        <my-img
          class={style['aImg-complete']}
          src={imgUrl}
          options={{ type: 'div' }}
        ></my-img>
        {/* 如果业主自定义的图片,则不再拼接游戏名称,只显示一张广告图就可以 */}
        {!isCustomIcon && <div class={style['game-name']}>{gameName}</div>}
      </my-img>
    )
  }
}
